// export const SERVER_URL = "http://localhost:5014";
export const SERVER_URL = "https://cmxbingobackend.cmxph.com";

//FOR THE VOICE URL ON THE FRONTEND
// export const VOICE_APP_URL = "https://voice.cmxph.com";
// or for local dev:
export const VOICE_APP_URL = "https://https://recruitment.cmxph.com";
